module.exports = __webpack_public_path__ + "static/media/black_stop_btn.18068eca.png";